import { Center, Grid, Heading, VStack } from "@chakra-ui/layout";
import { Card, Spinner } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type {
  BrandProfitSummaryQuery,
  ProjectProfitSummaryQuery,
} from "@src/__generated__/urql-graphql";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import { TopClientsGraph } from "../../../brand/common/top-clients-graph";
import type { ProjectReportStore } from "../../../project/common/store";
import { TopProjectsGraph } from "../../../project/common/top-projects-graph";
import { ProfitCard } from "../../components/profit-card";

export type ProfitSummaryProps = (
  | {
      type: "project";
      summary: ProjectProfitSummaryQuery["projectRevenueSummary"] | undefined;
    }
  | {
      type: "brand";
      summary: BrandProfitSummaryQuery["brandRevenueSummary"] | undefined;
    }
) & {
  isFetching: boolean;
  expenseBudgetCategories: ProjectReportStore["expenseBudgetCategories"];
};

export const ProfitSummary: FunctionComponent<ProfitSummaryProps> = observer(
  function ProfitSummary({
    summary,
    isFetching,
    expenseBudgetCategories,
    type,
  }) {
    return (
      <Grid templateColumns="0.65fr 0.35fr" p="4" columnGap="4">
        <ProfitCard
          summary={summary}
          isFetching={isFetching}
          expenseBudgetCategories={expenseBudgetCategories}
        />
        <Card p="4" bg="grey.50">
          {isFetching ? (
            <Center minH="32">
              <Spinner size="xl" />
            </Center>
          ) : type === "project" ? (
            <VStack w="full" h="full" align="start">
              <Heading fontSize="xl">
                <Trans>Top Projects (by Profit)</Trans>
              </Heading>
              <TopProjectsGraph
                data={summary?.profit_top_projects ?? []}
                expenseBudgetCategories={expenseBudgetCategories}
              />
            </VStack>
          ) : (
            <VStack w="full" h="full" align="start">
              <Heading fontSize="xl">
                <Trans>Top Clients (by Profit)</Trans>
              </Heading>
              <TopClientsGraph data={summary?.profit_top_clients ?? []} />
            </VStack>
          )}
        </Card>
      </Grid>
    );
  },
);
